import { App } from "../../App";
import { AppMode } from "../../AppMode";
import { Question } from "./Question";
import { QuestionGroup } from "./QuestionGroup";
import { Quiz } from "./Quiz";
import { QuizCountry } from "./QuizCountry";
import { UKQuiz } from "./UKQuiz";
import { WorldQuiz } from "./WorldQuiz";

export class QuizQuestionManager 
{
    private worldQuiz: WorldQuiz;
    private ukQuiz: UKQuiz;

    private usedQuestionIds: Array<string> = [];

    constructor(private appMode: AppMode)
    {
        this.worldQuiz = new WorldQuiz();
        this.ukQuiz = new UKQuiz();
    }

    private createUKQuiz(): Array<Question>
    {
        let questions = this.shuffleArray(this.ukQuiz.questions);
        let quizQuestions: Array<Question> = this.pickRandomUnusedQuestions(questions);

        if (quizQuestions.length !== 10)
        {
            // Clear out used question ids and pump in other questions again
            this.usedQuestionIds = [];

            // Populate with questions we've already got
            quizQuestions.map(q => this.usedQuestionIds.push(q.id));

            // Add new questions to bulster the count
            let newQuestions: Array<Question> = this.pickRandomUnusedQuestions(questions);
            for (let i = 0; i < newQuestions.length; i++)
            {
                let q: Question = newQuestions[i];
                if (quizQuestions.length <= 9)
                {
                    quizQuestions.push(q);
                }
            }
        }

        return quizQuestions;
    }

    private pickRandomUnusedQuestions(questions: Array<Question>): Array<Question> 
    {
        let quizQuestions: Array<Question> = [];
        for (let j = 0; j < questions.length; j++)
        {
            let question: Question = questions[j];

            if (this.usedQuestionIds.indexOf(question.id) > -1)
            {
                console.log("Skipping this question, we've used it already");
                continue;
            }

            if (quizQuestions.length <= 9)
            {
                quizQuestions.push(question);
                this.usedQuestionIds.push(question.id);
            }
            else
            {
                break;
            }
        }
        return quizQuestions;
    }

    private pickRandomUnusedQuestionsWithEachCountry(questions: Array<Question>): Array<Question>
    {
        let quizQuestions: Array<Question> = [];
        let quizCountries = [
            QuizCountry.Australia,
            QuizCountry.Canada,
            QuizCountry.Egypt,
            QuizCountry.France,
            QuizCountry.Japan,
            QuizCountry.UK,
            QuizCountry.USA
        ];

        let filledByCountry: Array<QuizCountry> = [];

        for (let i = 0; i < quizCountries.length; i++)
        {
            let quizCountry: QuizCountry = quizCountries[i];

            if (filledByCountry.indexOf(quizCountry) > -1)
            {
                continue;
            }

            for (let j = 0; j < questions.length; j++)
            {
                let question: Question = questions[j];

                if (this.usedQuestionIds.indexOf(question.id) > -1)
                {
                    continue;
                }

                if (quizQuestions.length <= 9)
                {
                    quizQuestions.push(question);
                    this.usedQuestionIds.push(question.id);
                    filledByCountry.push(quizCountry);
                }
                else
                {
                    break;
                }
            }
        }

        return quizQuestions;
    }

    private createWorldQuiz(): Array<Question> 
    {
        let questions = this.shuffleArray(this.worldQuiz.questions);
        let quizQuestions: Array<Question> = this.pickRandomUnusedQuestionsWithEachCountry(questions);

        if (quizQuestions.length !== 10)
        {
            // Clear out used question ids and pump in other questions again
            this.usedQuestionIds = [];

            // Populate with questions we've already got
            quizQuestions.map(q => this.usedQuestionIds.push(q.id));

            // Add new questions to bulster the count
            let newQuestions: Array<Question> = this.pickRandomUnusedQuestionsWithEachCountry(questions);
            for (let i = 0; i < newQuestions.length; i++)
            {
                let q: Question = newQuestions[i];
                if (quizQuestions.length <= 9)
                {
                    quizQuestions.push(q);
                }
            }
        }
        return quizQuestions;
    }

    public createQuiz(onQuizFinished: () => void): Quiz
    {
        let quizQuestions: Array<Question> = [];
        if (this.appMode === AppMode.Arrivals)
        {
            // UK Quiz
            quizQuestions = this.createUKQuiz();
        }
        else 
        {
            quizQuestions = this.createWorldQuiz();
        }
        return new Quiz(quizQuestions, onQuizFinished);
    }

    private shuffleArray(array: Array<any>)
    {
        for (let i = array.length - 1; i > 0; i--)
        {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    public markQuizComplete(quiz: Quiz): void
    {
    }
}